import { mutator } from 'satcheljs';
import getStore from '../store/getStore';
import * as action from '../actions/advertisingOptionsActions';
import getOptions from '../selectors/getOptions';
mutator(action.toggleAllowAccess, function (msg) {
    var options = getOptions();
    getStore().allowAccess = !options.allowAccess;
});
mutator(action.toggleAllowPersonalization, function (msg) {
    var options = getOptions();
    getStore().allowPersonalization = !options.allowPersonalization;
});
mutator(action.toggleAllowAdSelection, function (msg) {
    var options = getOptions();
    getStore().allowAdSelection = !options.allowAdSelection;
});
mutator(action.toggleAllowContentSelection, function (msg) {
    var options = getOptions();
    getStore().allowContentSelection = !options.allowContentSelection;
});
mutator(action.toggleAllowMeasurement, function (msg) {
    var options = getOptions();
    getStore().allowMeasurement = !options.allowMeasurement;
});
mutator(action.setOptions, function (msg) {
    Object.keys(msg.options).forEach(function (key) {
        getStore()[key] = msg.options[key];
    });
});
//# sourceMappingURL=advertisingOptionsMutators.js.map